// Master Reporting Reducer
import {
  GET_MASTER_REPORTING_ITEMS,
  GET_MASTER_REPORTING_ITEMS_SUCCESS,
  GET_MASTER_REPORTING_ITEMS_FAILURE,
} from "./actionType";

const initialState = {
  masterReportingItems: [],
  loading: false,
  error: null,
};

const MasterReporting = (state = initialState, action) => {
  switch (action.type) {
    case GET_MASTER_REPORTING_ITEMS:
      return {
        ...state,
        loading: true,
      };
    case GET_MASTER_REPORTING_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        masterReportingItems: action.payload,
      };
    case GET_MASTER_REPORTING_ITEMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default MasterReporting;
